export const new_security_transfer = `subscription new_security_transfer{
    new_security_transfer{
        transaction_code
        status
        account
        security{
            short_name
            name
            stock_market_locality
            currency{
                currency
                name
                decimal
            }
        }
        amount
        order_date
    }
}`;
